<template>
  <div>
    <div class="other-container global-full-fixed global-blur" :style="{backgroundImage: 'url(' + bg_url + ')'}" style="background-position:center;"></div>
    <div class="contents-containers">
      <!-- 卡片信息容器 -->
      <div class="cart-containers">
        <!-- 头部 -->
        <div class="cartimg-box" @click="gototemplate" :style="{backgroundImage: 'url(' + bg_url + ')'}">
          <button v-if="id && id != detailmsg.own_id" class="cu-btn linkto-cart" @click.stop="gotoowncart">
            <span class>我的名片</span>
            <img class="linkto-enter" :src="homeIconEnterb" mode="widthFix" />
          </button>
          <button v-else class="cu-btn linkto-cart" @click.stop="gotocart">
            <img class="linkto-box" :src="homeIconBox" mode="widthFix" />
            <span class>名片盒子</span>
          </button>
          <img class="cu-avatar qcode-icon" @click.stop="gotocartcode" :src="homeIconCode" alt />
        </div>
        <!-- 中间 -->
        <div class="message-box">
          <!-- 1 -->
          <div class="flex align-center message-top solid-bottoms">
            <img v-if="detailmsg.avatar_url" class="cu-avatar round weixin-img" :data-avaimg="detailmsg.avatar_url" @click="handleimgPrediv" :src="detailmsg.avatar_url" alt />
            <img v-else class="cu-avatar round weixin-img" :data-avaimg="guideIconSlider" @click="handleimgPrediv" :src="guideIconSlider" alt="默认头像" />
            <div class="topmessage-center">
              <div class="name-position" v-if="!iswrap">
                <span class>{{detailmsg.name?detailmsg.name:'默认昵称'}}</span>
                <span class>{{detailmsg.job_title}}</span>
              </div>
              <div class="name-position" v-else>
                <div class>{{detailmsg.name?detailmsg.name:'默认昵称'}}</div>
                <div class>{{detailmsg.job_title}}</div>
              </div>
              <div class="handle-events">
                <div v-if="id && id != detailmsg.own_id">
                  <button v-if="detailmsg.is_follow == 0" class="cu-btn btns-focus focus-no-active" @click="handleFocus" :data-id="detailmsg.id">+关注</button>
                  <button v-if="detailmsg.is_follow == 1" class="cu-btn btns-focus focus-active" @click="handleFocus" :data-id="detailmsg.id">已关注</button>
                   <button class="cu-btn btns-focus change-no-active">交换名片</button>
                   <!--  <button class="cu-btn btns-focus change-active">已交换</button> -->
                  <!--                   <button
                    class="cu-btn btn-addcontent addcontent-active"
                    :data-nickname="detailmsg.wx_nickname"
                    :data-firstname="detailmsg.name"
                    :data-phonenumber="detailmsg.tel"
                    @click="handleaddPhone"
                  >保存通讯录</button>-->
                </div>
                <div v-else>
                  <button class="cu-btn btns-focus focus-no-active" :data-userid="detailmsg.id" @click="handleUpdateCart">编辑名片</button>
                  <button class="cu-btn btn-addcontent addcontent-active" @click="showPopup" open-type="share" ::data-nickname="detailmsg.wx_nickname" ::data-firstname="detailmsg.name" ::data-phonenumber="detailmsg.tel" v-clipboard:copy="config.link">分享名片</button>
                  <!--                   <button
                    class="cu-btn btn-addcontent addcontent-active"
                    @click="actionSheet"
                    open-type="share"
                    :data-nickname="detailmsg.wx_nickname"
                    :data-firstname="detailmsg.name"
                    :data-phonenumber="detailmsg.tel"
                  >分享名片</button>-->
                </div>
              </div>
            </div>
            <div class="topmessage-right" @click="handleZan" :data-id="detailmsg.id">
              <div class="flex justify-center align-center">
                <img class="zan-img" v-if="detailmsg.is_nice == 1" :src="homeBtnSpectrumSelected" mode="widthFix" />
                <img class="zan-img" v-else :src="homeBtnSpectrumNormal" mode="widthFix" />
              </div>
              <div class="zan-text">
                <span>靠谱：</span>
                <span>{{detailmsg.nices_num}}</span>
              </div>
            </div>
          </div>
          <!-- 2 -->
          <div class="message-center cu-list menu solid-bottoms">
            <div class="cu-item message-options" v-if="companyData.company_name" data-target="conText" @click="showModals">
              <div class="content flex grey-font-size">
                <div class="flex align-center" style="align-items:flex-start;">
                  <img class="left-company-icons" :src="homeIconCompany" />
                </div>
                <span class="spans-greys span-location">{{companyData.company_name}}</span>
              </div>
              <img class="cu-avatar arrows-enters" :src="homeIconEnter" alt />
            </div>
            <div v-else>
              <div class="cu-item message-options" v-if="id && id != detailmsg.own_id">
                <div class="content flex grey-font-size">
                  <div class="flex align-center" style="align-items:flex-start;">
                    <img class="left-company-icons" :src="homeIconCompany" />
                  </div>
                  <span class="spans-greys span-location">公司信息待完善</span>
                </div>
                <img class="cu-avatar arrows-enters" :src="homeIconEnter" alt />
              </div>
              <div class="cu-item message-options" v-else :data-userid="detailmsg.id" @click="handleUpdateCart">
                <div class="content flex grey-font-size">
                  <div class="flex align-center" style="align-items:flex-start;">
                    <img class="left-company-icons" :src="homeIconCompany" />
                  </div>
                  <span class="spans-greys span-location">公司信息待完善</span>
                </div>
                <img class="cu-avatar arrows-enters" :src="homeIconEnter" alt />
              </div>
            </div>

            <div class="cu-item message-options" :data-phonenum="detailmsg.tel?detailmsg.tel:myphone" :data-istelshow="detailmsg.is_tel_show" @click="handleCall">
              <div class="content flex grey-font-size">
                <div class="flex align-center" style="align-items:flex-start;">
                  <img style="margin-left:-1px;" class="left-company-icons" :src="homeIconPhone" />
                </div>
                <span class="spans-greys" style="display:inline-block;">{{detailmsg.tel?detailmsg.tel:myphone}}</span>
              </div>
              <img class="cu-avatar arrows-enters" :src="homeIconEnter" alt />
            </div>

            <div class="cu-item message-options" v-if="detailmsg.wx_no" data-target="img" :data-wxnum="detailmsg.wx_no" :data-wxqcode="detailmsg.qr_code" @click="showModals">
              <div class="content flex grey-font-size">
                <div class="flex align-center" style="align-items:flex-start;">
                  <img class="left-company-icons" :src="homeIconWx" />
                </div>
                <span class="spans-greys">{{detailmsg.wx_no}}</span>
              </div>
              <img class="cu-avatar arrows-enters" :src="homeIconEnter" alt />
            </div>
            <div v-else>
              <div class="cu-item message-options" v-if="id && id != detailmsg.own_id">
                <div class="content flex grey-font-size">
                  <div class="flex align-center" style="align-items:flex-start;">
                    <img class="left-company-icons" :src="homeIconWx" />
                  </div>
                  <span class="spans-greys">微信号待完善</span>
                </div>
                <img class="cu-avatar arrows-enters" :src="homeIconEnter" alt />
              </div>
              <div class="cu-item message-options" v-else :data-userid="detailmsg.id" @click="handleUpdateCart">
                <div class="content flex grey-font-size">
                  <div class="flex align-center" style="align-items:flex-start;">
                    <img class="left-company-icons" :src="homeIconWx" />
                  </div>
                  <span class="spans-greys">微信号待完善</span>
                </div>
                <img class="cu-avatar arrows-enters" :src="homeIconEnter" alt />
              </div>
            </div>

            <div class="cu-item message-options" v-if="companyData.location" :data-location="companyData.location" :data-lng="companyData.longitude" :data-lat="companyData.latitude" @click="handleLocation">
              <div class="content flex grey-font-size" hover-class="none">
                <div class="flex align-center" style="align-items:flex-start;">
                  <img class="left-company-icons" :src="homeIconAdress" />
                </div>
                <span class="spans-greys span-location">{{companyData.location}}{{companyData.detail}}</span>
              </div>
              <img class="cu-avatar arrows-enters" :src="homeIconEnter" alt />
            </div>
            <div v-else>
              <div class="cu-item message-options" v-if="id && id != detailmsg.own_id">
                <div class="content flex grey-font-size" hover-class="none">
                  <div class="flex align-center" style="align-items:flex-start;">
                    <img class="left-company-icons" :src="homeIconAdress" />
                  </div>
                  <span class="spans-greys span-location">地理位置待完善</span>
                </div>
                <img class="cu-avatar arrows-enters" :src="homeIconEnter" alt />
              </div>
              <div class="cu-item message-options" v-else :data-userid="detailmsg.id" @click="handleUpdateCart">
                <div class="content flex grey-font-size" hover-class="none">
                  <div class="flex align-center" style="align-items:flex-start;">
                    <img class="left-company-icons" :src="homeIconAdress" />
                  </div>
                  <span class="spans-greys span-location">地理位置待完善</span>
                </div>
                <img class="cu-avatar arrows-enters" :src="homeIconEnter" alt />
              </div>
            </div>
          </div>
          <!-- 3 -->
          <div class="dialogs-box solid-bottoms">
            <div class="van-col van-col--8 dt-dynamic" @click="gotoothercart">
              <img class :src="homeIconDynamic" />
              <span class>动态</span>
            </div>
            <div class="van-col van-col--8 dt-dynamic">
              <img class :src="homeBtnShopDisable" />
              <span class>商城即将上线</span>
            </div>
            <div class="van-col van-col--8 dt-dynamic">
              <img class :src="homeBtnWebsiteDisable" />
              <span class>官网即将上线</span>
            </div>
          </div>
          <!-- 4 自我介绍 -->
          <div class="about-us-box">
            <div class="about-titles flex align-center">
              <span class="before-icons"></span>
              <span class="span-myself">自我介绍</span>
            </div>
            <div class="about-contents">{{detailmsg.remark}}</div>
            <div v-if="detailmsg.voice_remark" class="form-voice-show form-voice-show-active flex align-center" @click="handlePlay">
              <audio ref="audiobox" style="display:none;" controls @ended="handlePause" :src="detailmsg.voice_remark"></audio>
              <span>播放语音{{detailmsg.voice_len}}s"</span>
              <img v-if="isPlay" class="cu-avatar global-back-transform icon-voices" :src="boFang" />
              <img v-else class="cu-avatar global-back-transform icon-voices" :src="homeIconVoice" alt />
            </div>
          </div>
        </div>
      </div>

      <!-- 创建名片 -->
      <div v-if="detailmsg.own_reg_status==0" class="flex justify-center" @click="linktocartform">
        <button class="cu-btn btns-create-cart">
          <span class>鲜枇杷名片出品</span>
          <span class="create-my-carts">我也要创建名片</span>
          <img class="linkto-enter" :src="homeIconEntera" />
        </button>
      </div>

      <!-- 消息 xl radius -->
      <div class="global-message-btn cu-avatar round" @click="linktoMessage" :data-id="detailmsg.id" :data-name="detailmsg.name">
        <div v-if="detailmsg.msg_num > 0" class="cu-tag badge red-dot-badge">{{detailmsg.msg_num}}</div>
        <!--   <div  style="background-image:url({{baseimgurl}}/xianpipa/images/home_icon_message.png)"></div> -->
        <img class="cu-avatar message-icons global-back-transform" :src="homeIconMessage" />
        <span class="btn-inner-text">消息</span>
      </div>

      <!-- 模态框 -->
      <div class="cu-modal" :class="modalName=='conText'?'show':''">
        <div class="cu-dialog compons-modals" style="padding:1.12rem 1.22rem 0.66rem 1.17rem;">
          <img :src="homeIconClose" class="cu-avatar componts-close-btn" @click="hideModel" />
          <div class="inner-compons-modals">
            <div class="compons-modals-title flex align-center">
              <span class="before-icons"></span>
              <span>企业介绍</span>
            </div>
            <div class="compons-modals-content span-indent" style="text-indent: 30px;">{{companyData.company_remark}}</div>
          </div>
        </div>
      </div>
      <div class="cu-modal" :class="modalName=='img'?'show':''">
        <div class="cu-dialog compons-modals" style="height:22rem;padding: 1.52rem 1rem 1.70rem;">
          <div class="inner-compons-modals" style="width: 13.701rem;padding: 0 1.06rem;">
            <img class="cu-avatar componts-close-btn" @click="hideModel" :src="homeIconClose" alt />
            <div class="flex align-center">
              <!--  <img
                class="cu-avatar radius weixin-avatarUrl"
                :src="detailmsg.wx_avatar?detailmsg.wx_avatar:detailmsg.avatar_url"
                alt
              />-->
              <img class="cu-avatar radius weixin-avatarUrl" :src="detailmsg.avatar_url" alt />
              <div class="img-top-message">
                <div class="wexin-topname">{{detailmsg.wx_nickname?detailmsg.wx_nickname:detailmsg.name}}</div>
                <div class="wexin-toparea" v-if="detailmsg.province">{{detailmsg.province}} {{detailmsg.city}}</div>
              </div>
            </div>
            <div v-if="detailmsg.wx_no<16" class="flex lines-copys">
              <span>微信号：{{detailmsg.wx_no}}</span>
              <div class="weixin-copy" v-clipboard:copy="detailmsg.wx_no" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</div>
            </div>
            <div v-else style="font-size:0.6486486486486487rem;" class="flex lines-copys">
              <span>微信号：{{detailmsg.wx_no}}</span>
              <div class="weixin-copy" v-clipboard:copy="detailmsg.wx_no" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</div>
            </div>
            <div class="compons-modals-content">
              <img class="modal-qcode-img" :src="detailmsg.qr_code" onclick="return false" />
            </div>
            <div class="models-bottom-tips">扫一扫上面的二维码图案，加我微信</div>
          </div>
        </div>
      </div>
    </div>

    <!--分享到-->
    <van-popup v-model="showpopup" position="bottom" :style="{ height: '50%' }">
      <div class="sharedownbox">
        <vue-native-share :shareMenu="shareMenu" :config="config" />
      </div>
      <van-button class="sharetopbox" @click="closepopup" type="default" block>取消分享</van-button>
    </van-popup>
  </div>
</template>

<script>
import { getindexcartMsg, updateStatus } from "../../api/api";
import global from "../../global/global.vue";
import Vue from "vue";
import { ImagePreview, Toast, Dialog } from "vant";
import vueNativeShare from "../plugins/vue-native-share";

// 全局注册
Vue.use(ImagePreview);
Vue.use(Toast);
Vue.use(Dialog);

let audionum = 0;

export default {
  name: "mindex",
  components: { vueNativeShare },
  data () {
    return {
      imgUrl: global.apiglobal,
      baseimgurl: global.apiglobal,
      /* bg_url: 'global.bgurl', */
      bg_url: window.localStorage.getItem("bgurl") || global.bgurl,
      id: "",
      modalName: "",
      detailmsg: {},
      companyData: {
        company_name: "厦门龙商网络有限公司",
        company_remark: "这里是企业介绍",
        detail: "思明南路",
        latitude: "24.44579",
        location: "福建省厦门市思明区民族路33号",
        longitude: "118.08243"
      },
      isPlay: false,
      iswrap: false,
      myphone: "",
      showpopup: false,
      shareMenu: [0, 1, 2, 3],
      config: {
        url: '',
        title: "鲜枇杷名片",
        desc: "免费为企业/个人制作电子名片，扫描二维码生成你的专属电子名片",
        img:
          "https://api.xianpipa.com/xianpipa/images/logo.png",
        img_title: "一款名片应用",
        link: "", //执行代码时会赋值
        success: () => {
          console.log("success");
        },
        cancel: () => {
          console.log("cancel");
        }
      },
      homeIconEnterb: require("../../assets/images/home_icon_enterb.png"),
      homeIconBox: require("../../assets/images/home_icon_box.png"),
      homeIconCode: require("../../assets/images/home_icon_code.png"),
      guideIconSlider: require("../../assets/images/guide_icon_slider.png"),
      homeBtnSpectrumSelected: require("../../assets/images/home_btn_spectrum_selected.png"),
      homeBtnSpectrumNormal: require("../../assets/images/home_btn_spectrum_normal.png"),
      homeIconCompany: require("../../assets/images/home_icon_company.png"),
      homeIconEnter: require("../../assets/images/home_icon_enter.png"),
      homeIconPhone: require("../../assets/images/home_icon_phone.png"),
      homeIconWx: require("../../assets/images/home_icon_wx.png"),
      homeIconAdress: require("../../assets/images/home_icon_adress.png"),
      homeIconDynamic: require("../../assets/images/home_icon_dynamic.png"),
      homeBtnShopDisable: require("../../assets/images/home_btn_shop_disable.png"),
      homeBtnWebsiteDisable: require("../../assets/images/home_btn_website_disable.png"),
      boFang: require("../../assets/images/bofang.gif"),
      homeIconVoice: require("../../assets/images/home_icon_voice.png"),
      homeIconEntera: require("../../assets/images/home_icon_entera.png"),
      homeIconMessage: require("../../assets/images/home_icon_message.png"),
      homeIconClose: require("../../assets/images/home_icon_close.png")
    };
  },

  created () {
    document.title = "我的名片";
    //分享路径

    window.scrollTo(0, 0);
    var that = this;
    this.myphone = localStorage.getItem("telphone");

    let detailmsg = that.$store.getters.getDetailmsg;
    if (detailmsg.name != null && detailmsg != "") {
      that.detailmsg = detailmsg;
      var url = window.location.host + "/#/othercart?id=" + detailmsg.id;
      that.config.link = url;
      that.config.url = window.location.href;
      that.companyData = detailmsg.company_info;
    } else {
      getindexcartMsg()
        .then(res => {
          if (res.data.code == 200) {
            this.$store.dispatch("changeDetailmsgFun", res.data.data);
            that.detailmsg = res.data.data;
            that.companyData = res.data.data.company_info;
            var url =
              window.location.host + "/#/othercart?id=" + res.data.data.id;
            that.config.link = url;
            that.config.url = window.location.href;
            if (
              that.detailmsg.name.length + that.detailmsg.job_title.length >
              12
            ) {
              that.iswrap = true;
            }
            if (that.detailmsg.bg_url != "") {
              this.bg_url = that.detailmsg.bg_url;
              window.localStorage.setItem("bgurl", that.detailmsg.bg_url);
            }
          }
        })
        .catch(err => {
        });
    }
  },
  activated () {
    this.bg_url = window.localStorage.getItem("bgurl") || global.bgurl;
  },
  updated () {
    //分享给其他人的地址
  },
  methods: {
    /*    actionSheet() {
      Mshare.popup(this.config);
    }, */
    showPopup () {
      if (/micromessenger/i.test(navigator.userAgent)) {
        //微信复制链接
        Toast.success({
          duration: 2000,
          message: "链接已复制，快去分享吧！"
        });

      } else {
        this.showpopup = true;
      }

    },
    gototemplate () {
      this.$router.push({
        name: "cartemplate"
      });
    },
    closepopup () {
      this.showpopup = false;
    },
    //动态
    gotoothercart: function () {
      this.$router.push({
        name: "dynamic"
      });
    },
    //我的名片
    gotoowncart: function () {
      //
    },
    //名片码
    gotocartcode: function () {
      this.$router.push({
        name: "cartcode",
        query: {
          id: this.detailmsg.id,
          isown: true
        }
      });
    },
    linktocartform: function () {
      this.$router.push({
        name: "cartform"
      });
    },
    linktoMessage: function () {
      this.$router.push({
        name: "messagelist"
      });
    },
    gotocart: function () {
      this.$router.push({
        name: "cartbox"
      });
    },
    handleUpdateCart: function (e) {
      /*   this.$router.push({
        name: "cartform",
        params: {
          userid: e.currentTarget.dataset.userid
        }
      }); */
      this.$router.push({
        path: "/cartform",
        query: {
          userid: e.currentTarget.dataset.userid
        }
      });
    },
    handleimgPrediv: function (e) {
      let avaimg = e.target.dataset.avaimg;
      let avaimgObg = [];
      avaimgObg.push(avaimg);
      ImagePreview({
        images: avaimgObg,
        showIndex: false
      });
    },
    //靠谱和取消靠谱
    goodZan: function (item_id) {
      var that = this;
      var show; //传递到数据库点赞的状态
      var cookie_mid = this.$store.getters.getKaopu || []; //获取全部点赞的mid
      /*   var cookie_mid = wx.getStorageSync('kaopu') || []; //获取全部点赞的mid  */

      var newmessage = [];

      if (that.detailmsg.id == item_id) {
        //遍历找到对应的id

        updateStatus(item_id).then(res => {
          var isshow; //点赞的状态
          var num = that.detailmsg.nices_num; //点赞数
          if (cookie_mid.includes(item_id) || that.detailmsg.is_nice == 1) {
            //说明已经点过赞,取消赞
            for (var j = 0; j < cookie_mid.length; j++) {
              if (cookie_mid[j] == item_id) {
                cookie_mid.splice(j, 1); //删除取消赞的mid
              }
            }
            isshow = 0; //点赞的状态
            num--;
            that.detailmsg.is_nice = isshow;
            that.detailmsg.nices_num = num;

            /*   wx.setStorageSync('kaopu', cookie_mid); */
            this.$store.dispatch("changeKaopuFun", cookie_mid);
          } else {
            isshow = 1; //点赞的状态
            num++;
            that.detailmsg.is_nice = isshow;
            that.detailmsg.nices_num = num;

            cookie_mid.unshift(item_id); //新增赞的mid
            this.$store.dispatch("changeKaopuFun", cookie_mid);
          }
        });

        /*  updateStatus(item_id).then(res => {
                if (res.code == 200) {

                } else if (res.code == 409) {

                }

            }) */
      }
    },
    //靠谱
    handleZan: function (e) {
      var item_id = e.currentTarget.dataset.id;
      this.goodZan(item_id);
    },
    handleaddPhone: function () { },
    showModals: function (e) {
      let mtype = e.currentTarget.dataset.target;
      let wxqcodeimg = e.currentTarget.dataset.wxqcode;
      if (mtype == "img") {
        if (wxqcodeimg != "") {
          this.modalName = mtype;
        } else {
          this.modalName = "";
          this.$copyText(this.detailmsg.wx_no).then(
            function (e) {
              Toast.success({
                duration: 2000,
                message: "复制成功"
              });
            },
            function (e) {
              Toast.fail({
                duration: 2000,
                message: "复制失败"
              });
            }
          );
        }
      } else {
        this.modalName = mtype;
      }
    },
    handlePlay: function () {
      var audio = this.$refs.audiobox;
      if (audionum % 2 == 0) {
        this.isPlay = true;
        audio.play();
      } else {
        this.isPlay = false;
        audio.pause();
      }
      audionum++;
    },
    handlePause: function () {
      this.isPlay = false;
      audionum = 0;
    },
    handleCall: function (e) {
      let that = this;
      let phonenum = e.currentTarget.dataset.phonenum;
      let isTelShow = e.currentTarget.dataset.istelshow;
      if (isTelShow == 1) {
        Dialog.confirm({
          message: "拨打" + phonenum + "？"
        })
          .then(() => {
            // on confirm
            window.location.href = "tel:" + phonenum;
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    handleLocation: function (e) {
      let location = e.currentTarget.dataset.location;
      let lng = e.currentTarget.dataset.longitude;
      let lat = e.currentTarget.dataset.latitude;
      window.location.href =
        "https://apis.map.qq.com/tools/routeplan/eword=" +
        location +
        "&epointx=" +
        lng +
        "&epointy=" +
        lat +
        "?referer=鲜枇杷名片&key=BOTBZ-KK5WU-L7AVP-2IK2Y-MR3Y3-MDBR4";
    },
    hideModel: function () {
      this.modalName = "";
    },
    onCopy (e) {
      Toast.success({
        duration: 2000,
        message: "复制成功"
      });
    },
    // 复制失败
    onError (e) {
      Toast.fail({
        duration: 2000,
        message: "复制失败"
      });
    },
    //关注
    goodFocus: function (item_id) {
      var that = this;
      var show; //传递到数据库点赞的状态
      //var cookie_mid = wx.getStorageSync('Focus') || [];
      var cookie_mid = this.$store.getters.getFocus || []; //获取全部点赞的mid
      var newmessage = [];

      if (that.detailmsg.id == item_id) {
        //遍历找到对应的id

        var isshow; //点赞的状态

        if (cookie_mid.includes(item_id) || that.detailmsg.is_follow == 1) {
          //说明已经点过赞,取消赞
          for (var j = 0; j < cookie_mid.length; j++) {
            if (cookie_mid[j] == item_id) {
              cookie_mid.splice(j, 1); //删除取消赞的mid
            }
          }
          isshow = 0; //点赞的状态
          that.detailmsg.is_follow = isshow;
          that.$store.dispatch("changeFocusFun", cookie_mid);
        } else {
          isshow = 1; //点赞的状态
          that.detailmsg.is_follow = isshow;
          cookie_mid.unshift(item_id); //新增赞的mid
          that.$store.dispatch("changeFocusFun", cookie_mid);
        }
      }
    },
    //关注他人
    handleFocus: function (e) {
      var item_id = e.currentTarget.dataset.id; //此处找到列表的id
      this.goodFocus(item_id);
    }
  },
  activated () {
    window.scrollTo(0, 0);
    var that = this;
    this.myphone = localStorage.getItem("telphone");

    let detailmsg = that.$store.getters.getDetailmsg;
    if (detailmsg.name != null && detailmsg != "") {
      that.detailmsg = detailmsg;
      that.companyData = detailmsg.company_info;
    } else {
      getindexcartMsg()
        .then(res => {
          if (res.data.code == 200) {
            this.$store.dispatch("changeDetailmsgFun", res.data.data);
            that.detailmsg = res.data.data;
            that.companyData = res.data.data.company_info;
            if (
              that.detailmsg.name.length + that.detailmsg.job_title.length >
              12
            ) {
              that.iswrap = true;
            }
            if (that.detailmsg.bg_url != "") {
              this.bg_url = that.detailmsg.bg_url;
              window.localStorage.setItem("bgurl", that.detailmsg.bg_url);
            }
          }
        })
        .catch(err => {
        });
    }

    this.bg_url = window.localStorage.getItem("bgurl") || global.bgurl;
  }
};
</script>

<style scoped>
@keyframes fadeio {
  /*设置内容由显示变为隐藏*/
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.hidefade {
  display: none;
}
/* .img-top-message {
  align-items: flex-start;
} */
.collect-tip {
  width: 12.91891891891892rem;
  display: flex;
  position: absolute;
  top: 3.72972972972973rem;
  right: 0.5405405405405406rem;
  padding: 0.5675675675675675rem;
  border-radius: 0.40540540540540543rem;
  background-color: #fff;
  font-size: 0.8108108108108109rem;
  color: #333;
  letter-spacing: 0.02702702702702703rem;
  line-height: 1.135135135135135rem;
}
.collect-tip::after {
  content: "";
  width: 0.5405405405405406rem;
  height: 0.5405405405405406rem;
  background: #fff;
  position: absolute;
  top: -0.2702702702702703rem;
  right: 3.189189189189189rem;
  transform: rotate(45deg);
}
.collect-tip .collect-tip-icon {
  font-size: 1.027027027027027rem;
  color: #d4d4d4;
}
.collect-tip .circular-icon {
  font-size: 0.5405405405405406rem;
  margin: -0.2972972972972973rem;
}
.collect-tip .big-icon {
  font-size: 0.8378378378378378rem;
  position: relative;
  top: 0.08108108108108109rem;
}
/* pages/login/othercart/othercart.wxss */
page {
  width: 100%;
  height: 100%;
}
.flex {
  display: flex;
}
.align-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.other-container {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
}
.global-full-fixed {
  z-index: 0;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
/* 毛玻璃效果 */
.global-blur {
  filter: blur(5px);
  -webkit-filter: blur(6px);
  -moz-filter: blur(6px);
  -ms-filter: blur(6px);
  filter: blur(6px);
  filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=10, MakeShadow=false);
}
.login-containers {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: #f2f2f2;
  opacity: 0.99;
}
.contents-containers {
  width: 100%;
  padding-bottom: 3.7rem;
}
/* 卡信息容器 */
.cart-containers-opacity {
  margin: 3.72972972972973rem 0.8108108108108109rem 0 0.8108108108108109rem;
  min-height: 35.945945945945944rem;
  background: #ffffff;
  opacity: 0.92;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: -1;
  border-radius: 2.1621621621621623rem 0.5945945945945946rem
    2.1621621621621623rem 0.5945945945945946rem;
  overflow: hidden;
}
.cart-containers {
  margin: 3.72972972972973rem 0.8108108108108109rem 0 0.8108108108108109rem;
  min-height: 31.756756756756758rem;
  background: #ffffff;
  opacity: 0.92;
  border-radius: 2.1621621621621623rem 0.5945945945945946rem
    2.1621621621621623rem 0.5945945945945946rem;
  overflow: hidden;
  margin-top: 0.3rem;
}
/* 头部 */
.cartimg-box {
  width: 100%;
  height: 8.64864864864865rem;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
.cu-btn {
  position: relative;
  border: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 0.8rem;
  font-size: 0.74rem;
  height: 1.7rem;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  overflow: visible;
  margin-left: initial;
  transform: translate(0, 0);
  margin-right: initial;
}
.linkto-cart {
  padding: 0 0.43243243243243246rem;
  height: 1.4054054054054055rem;
  line-height: 1.4054054054054055rem;
  color: #ffffff;
  font-size: 0.7027027027027027rem;
  background-image: linear-gradient(90deg, #ffbd0a, #f9da5b);
  border-radius: 0.7027027027027027rem;
  position: absolute;
  top: 0.5945945945945946rem;
  right: 0.6216216216216216rem;
}
.linkto-cart .linkto-box {
  width: 0.972972972972973rem;
  height: 0.7567567567567568rem;
  margin-right: 0.16216216216216217rem;
}
.linkto-enter {
  width: 0.2972972972972973rem;
  height: 0.5675675675675675rem;
  margin-left: 0.32432432432432434rem;
}
.qcode-icon {
  width: 1.5675675675675675rem;
  height: 1.5135135135135136rem;
  position: absolute;
  bottom: 0.4594594594594595rem;
  right: 0.6216216216216216rem;
  border-radius: 0.2702702702702703rem;
  background-color: transparent;
}
/* 中间 */
/* 1 */
.message-box {
  width: 17.12rem;
  padding: 0 0.648rem;
}
.message-top {
  display: flex;
  align-items: center;
  padding: 0.7837837837837838rem 0;
  position: relative;
  color: #666666;
}
.weixin-img {
  width: 2.972972972972973rem;
  height: 2.972972972972973rem;
  margin-right: 0.8108108108108109rem;
  border-radius: 50%;
}
.name-position span:nth-of-type(1),
.name-position div:nth-of-type(1) {
  font-size: 0.918918918918919rem;
  color: #333333;
  margin-right: 0.6216216216216216rem;
  font-weight: 550;
  font-family: "SimHei";
  margin-bottom: 0.40540540540540543rem;
}
.name-position span:nth-of-type(2),
.name-position div:nth-of-type(2) {
  font-size: 0.7567567567567568rem;
  color: #666;
}
.handle-events {
  margin-top: 0.5945945945945946rem;
}
.btns-focus {
  width: 3.7837837837837838rem;
  height: 1.3513513513513513rem;
  line-height: 1.3513513513513513rem;
  font-size: 0.7027027027027027rem;
  border-radius: 0.6756756756756757rem;
  margin-right: 0.6486486486486487rem;
  padding: 0;
}
.cu-btn.focus-no-active {
  color: #ffffff;
  background-image: linear-gradient(90deg, #ffbd0a, #f9da5b);
}
.cu-btn.focus-active {
  border: 1px solid #ffbd0a;
  background-color: #ffffff;
  color: #ffbd0a;
}
.cu-btn.change-no-active {
  color: #ffffff;
  background-image: linear-gradient(90deg, #89d42f, #b3ef66);
}
.cu-btn.change-active {
  border: 1px solid #8cd632;
  background-color: #ffffff;
  color: #8cd632;
}
.btn-addcontent {
  height: 1.3513513513513513rem;
  line-height: 1.3513513513513513rem;
  font-size: 0.7027027027027027rem;
  padding: 0 0.5405405405405406rem;
  color: #ffffff;
  border-radius: 0.6756756756756757rem;
}
.addcontent-active {
  background-image: linear-gradient(90deg, #88d32d, #b5f067);
}
.topmessage-right {
  position: absolute;
  right: 0;
  bottom: 0.8378378378378378rem;
}
.zan-img {
  width: 1.135135135135135rem;
  height: 1.135135135135135rem;
  display: block;
}
.zan-text {
  font-size: 0.6486486486486487rem;
  margin-top: 0.5405405405405406rem;
}
.zan-text span:first-of-type {
  color: #999999;
}
.zan-text span:last-of-type {
  color: #ffbd0a;
}
/* 2 */
.message-center {
  padding-bottom: 0.2702702702702703rem;
  display: block;
  overflow: hidden;
  border-bottom: 1px solid #e0e0e0;
}
.cu-list.menu .cu-item {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cu-list > .cu-item {
  transition: all 0.6s ease-in-out 0s;
  transform: translateX(0rpx);
}

.cu-list.menu .cu-item .content {
  flex: 1;
  font-size: 0.74rem;
  color: #666;
}
.cu-list.menu .cu-item .content > div:first-child {
  display: flex;
  align-items: center;
  margin-right: 0.64rem;
}

.cu-list.menu .cu-item .grey-font-size {
  font-size: 0.7567567567567568rem;
}
.cu-list.menu .message-options {
  padding: 0;
}
.cu-list.menu .cu-item {
  min-height: 2.027027027027027rem;
  background-color: transparent;
}
.cu-list.menu .cu-item .content {
  line-height: 0.972972972972973rem;
}
/* .cu-list.menu > .cu-item .content > img {
  margin-right: 0.7567567567567568rem;
} */
.left-company-icons {
  width: 1.027027027027027rem;
  height: 0.972972972972973rem;
}
.arrows-enters {
  width: 0.3783783783783784rem;
  height: 0.7027027027027027rem;
  background-color: transparent;
}
.text-location {
  display: inline-block;
  width: 13.513513513513514rem;
}
.texts-greys {
  color: #666666;
}
.solid-bottoms {
  border-bottom: 0.02702702702702703rem solid #e0e0e0;
}
/* 3 */
.dialogs-box {
  height: 4.8108108108108105rem;
}
.dt-dynamic {
  height: 4.8108108108108105rem;
  font-size: 0.6486486486486487rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  padding-bottom: 0;
}
.dt-dynamic:nth-of-type(1) img {
  width: 1.6756756756756757rem;
  height: 1.6216216216216217rem;
  display: block;
  margin-bottom: 0.7027027027027027rem;
}
.dt-dynamic:nth-of-type(2) img {
  width: 1.7837837837837838rem;
  height: 1.5405405405405406rem;
  display: block;
  margin-bottom: 0.7027027027027027rem;
}
.dt-dynamic:nth-of-type(3) img {
  width: 1.6756756756756757rem;
  height: 1.6756756756756757rem;
  display: block;
  margin-bottom: 0.7027027027027027rem;
}
/* 4 自我介绍*/
.about-us-box {
  color: #666666;
  font-size: 0.7567567567567568rem;
  padding: 0.7567567567567568rem 0 1.2702702702702702rem 0;
}
.about-titles {
  font-size: 0.8108108108108109rem;
  color: #333333;
}
.before-icons {
  display: inline-block;
  width: 0.16216216216216217rem;
  height: 0.7567567567567568rem;
  background-color: #ffbd0a;
  margin-right: 0.2972972972972973rem;
}
.about-contents {
  padding: 0.5945945945945946rem 0.32432432432432434rem 0.5135135135135135rem
    0.32432432432432434rem;
}
.about-voice {
  padding: 0 0.32432432432432434rem 1rem 0.32432432432432434rem;
}
.btns-create-cart {
  height: 1.8918918918918919rem;
  font-size: 0.7027027027027027rem;
  color: #ffffff;
  border-radius: 0.9459459459459459rem;
  background-image: linear-gradient(0deg, #ffbd0a, #f9da5b);
  margin-top: 0.9459459459459459rem;
}
/* 消息 */
.global-message-btn {
  width: 2.864864864864865rem;
  height: 2.864864864864865rem;
  background-color: #88d32d;
  opacity: 0.8;
  position: fixed;
  right: 0.6486486486486487rem;
  bottom: 3.810810810810811rem;
  font-size: 0.32432432432432434rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.message-icons {
  width: 1.135135135135135rem;
  height: 1.054054054054054rem;
}
.global-topback-btn {
  width: 1.5675675675675675rem;
  height: 1.5675675675675675rem;
  position: fixed;
  top: 1.5405405405405406rem;
  left: 0.918918918918919rem;
}
.topback-btn-backgroud {
  width: 100%;
  height: 100%;
  position: relative;
}
.innertopback-btn-backgroud {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000000;
  opacity: 0.38;
  border-radius: 50%;
}
.topback-icons {
  width: 0.5945945945945946rem;
  height: 1rem;
}
.btn-inner-text {
  font-size: 0.6486486486486487rem;
  color: #ffffff;
  margin-top: 0.13513513513513514rem;
}
.create-my-carts {
  margin-left: 0.2972972972972973rem;
  font-size: 0.6486486486486487rem;
  letter-spacing: -0.02702702702702703rem;
  color: #f5495a;
  margin-top: 0.05405405405405406rem;
}
.fixed-bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
}
/* 去除每一行的下划线 */
.cu-list.menu .cu-item:after {
  border: none;
}
/* 模态框 */
/* img */
.img-top-message {
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.wexin-topname {
  font-size: 0.918918918918919rem;
  color: #333333;
  margin-bottom: 0.2702702702702703rem;
}
.wexin-toparea {
  font-size: 0.7027027027027027rem;
  color: #666666;
}
.lines-copys {
  font-size: 0.7567567567567568rem;
  padding: 0.2702702702702703rem 0 1rem;
}
.weixin-copy {
  display: inline-block;
  color: #6699ff;
  padding-left: 0.5945945945945946rem;
}
.modal-qcode-img {
  width: 14.35135135135135rem;
  height: 14.297297297297296rem;
}
.weixin-avatarUrl {
  width: 3.2432432432432434rem;
  height: 3.2432432432432434rem;
  border-radius: 0.40540540540540543rem;
}
.text-indent {
  text-indent: 1.5135135135135136rem;
}
/* 语音 */
.form-voice-show {
  width: 8.486486486486486rem;
  height: 1.837837837837838rem;
  font-size: 0.7027027027027027rem;
  border-radius: 0.32432432432432434rem;
  position: relative;
  margin-left: 0.2972972972972973rem;
}
.form-voice-show-no {
  color: #999999;
  background-color: #e4e4e4;
  border: solid 1px #dedede;
}
.form-voice-show-active {
  color: #88d32d;
  background-color: #e9fbce;
  border: solid 1px #88d32d;
  padding-left: 0.5405405405405406rem;
}
.icon-voices {
  width: 0.5945945945945946rem;
  height: 0.7567567567567568rem;
  position: absolute;
  right: 0.6756756756756757rem;
}
.cu-tag.badge {
  top: 0.2702702702702703rem;
}
/* 登录模态框 */
/*模态框开始 */
.login-model {
  width: 15.675675675675675rem;
  padding: 1.1081081081081081rem 0.972972972972973rem 1.135135135135135rem
    0.972972972972973rem;
}
.logo-img {
  width: 3.72972972972973rem;
  height: 3.72972972972973rem;
}
.login-tips {
  font-size: 0.918918918918919rem;
  line-height: 1.3513513513513513rem;
  color: #333333;
  margin: 1.135135135135135rem 0 1.0810810810810811rem 0;
}
.login-model-btn {
  width: 5.945945945945946rem;
  height: 2.1621621621621623rem;
  border-radius: 1.0810810810810811rem;
  color: #ffffff;
  background-image: linear-gradient(0deg, #ffbd0a, #f9da5b);
}
/*模态框结束 */
.inner-container {
  width: 85%;
  position: relative;
  margin: 4.054054054054054rem 0;
  background-color: lightcyan;
  border-top-left-radius: 1.6216216216216217rem;
  border-bottom-right-radius: 1.6216216216216217rem;
  overflow-y: auto;
}
.logo-messages {
  position: fixed;
  bottom: 4.054054054054054rem;
  right: 1.0810810810810811rem;
}
.userinfo {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
}
.userinfo-avatar {
  width: 3.4594594594594597rem;
  height: 3.4594594594594597rem;
  margin: 0.5405405405405406rem;
  border-radius: 50%;
}
/* template/popub/popub.wxss */
/* 模态框 */
.compons-modals {
  position: relative;
}
.inner-compons-modals {
  width: 100%;
  height: 100%;
}
.componts-close-btn {
  width: 1.3513513513513513rem;
  height: 1.3513513513513513rem;
  position: absolute;
  top: 1.054054054054054rem;
  right: 1.027027027027027rem;
  background-color: transparent;
  z-index: 90;
}
.compons-modals-title {
  font-size: 0.918918918918919rem;
  color: rgb(51, 51, 51);
  font-weight: bold;
  margin-bottom: 0.5405405405405406rem;
  width: 10.81081081081081rem;
  letter-spacing: 0.05405405405405406rem;
}
.compons-modals-content {
  height: 14.864864864864865rem;
  font-size: 0.7567567567567568rem;
  line-height: 1.3513513513513513rem;
  color: #666666;
  text-align: left;
  overflow: auto;
}
.before-icons {
  display: inline-block;
  width: 0.16216216216216217rem;
  height: 0.8648648648648649rem;
  background-color: #ffbd0a;
  margin-right: 0.4864864864864865rem;
  margin-bottom: -0.13513513513513514rem;
}
/* img */
.img-top-message {
  text-align: left;
  margin-left: 0.8378378378378378rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.wexin-topname {
  font-size: 0.918918918918919rem;
  color: #333333;
  margin-bottom: 0.2702702702702703rem;
  font-weight: 550;
  font-family: "SimHei";
}
.wexin-toparea {
  font-size: 0.7027027027027027rem;
  color: #666666;
}
.lines-copys {
  font-size: 0.7567567567567568rem;
  padding: 0.6756756756756757rem 0;
}
.weixin-copy {
  display: inline-block;
  color: #6699ff;
  padding-left: 0.5945945945945946rem;
}
.modal-qcode-img {
  width: 100%;
  height: 14.297297297297296rem;
}
.models-bottom-tips {
  font-size: 0.7027027027027027rem;
  color: #999999;
  margin-top: 0.5405405405405406rem;
}
/* swiper */
swiper {
  height: 14.378378378378379rem;
}
.slide-img {
  width: 100%;
  height: 100%;
}
.slide-icon {
  display: flex;
  justify-content: center;
}
.slide-icon .icon {
  width: 0.4594594594594595rem;
  height: 0.4594594594594595rem;
  background-color: #6599ff;
  border-radius: 50%;
  margin: 1.0810810810810811rem 0.2702702702702703rem 0;
}
.wx-swiper-dots {
  position: absolute;
}
.wx-swiper-dots.wx-swiper-dots-horizontal {
  bottom: -0.2702702702702703rem;
}
.icon-changeIndex {
  width: 1.4594594594594594rem;
  height: 1.4594594594594594rem;
  border-radius: 50%;
  position: absolute;
  top: 8.162162162162161rem;
  padding: 0.35135135135135137rem;
  z-index: 50;
}
.icon-clileft {
  left: 0;
}
.icon-cliright {
  right: 0;
}

/* ==================
         模态窗口
 ==================== */

.cu-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1110;
  opacity: 0;
  outline: 0;
  text-align: center;
  -ms-transform: scale(1.185);
  transform: scale(1.185);
  backface-visibility: hidden;
  perspective: 2000rpx;
  background: rgba(0, 0, 0, 0.6);
  transition: all 0.3s ease-in-out 0s;
  pointer-events: none;
}

.cu-modal::before {
  content: "\200B";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.cu-modal.show {
  opacity: 1;
  transition-duration: 0.3s;
  -ms-transform: scale(1);
  transform: scale(1);
  overflow-x: hidden;
  overflow-y: auto;
  pointer-events: auto;
}

.cu-dialog {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-left: auto;
  margin-right: auto;
  width: 15.84rem;
  max-width: 100%;
  background-color: #fff;
  border-radius: 0.26rem;
  overflow: hidden;
}

.cu-modal.bottom-modal::before {
  vertical-align: bottom;
}

.cu-modal.bottom-modal .cu-dialog {
  width: 100%;
  border-radius: 0;
}

.cu-modal.bottom-modal {
  margin-bottom: -26.66rem;
}

.cu-modal.bottom-modal.show {
  margin-bottom: 0;
}

.cu-modal.drawer-modal {
  transform: scale(1);
  display: flex;
}

.cu-modal.drawer-modal .cu-dialog {
  height: 100%;
  min-width: 5.33rem;
  border-radius: 0;
  margin: initial;
  transition-duration: 0.3s;
}

.cu-modal.drawer-modal.justify-start .cu-dialog {
  transform: translateX(-100%);
}

.cu-modal.drawer-modal.justify-end .cu-dialog {
  transform: translateX(100%);
}

.cu-modal.drawer-modal.show .cu-dialog {
  transform: translateX(0%);
}
.cu-modal .cu-dialog > .cu-bar:first-child .action {
  min-width: 2.66rem;
  margin-right: 0;
  min-height: 2.66rem;
}

.sharedownbox {
  padding-top: 0rem;
}
.sharetopbox {
  position: absolute;
  bottom: 0;
}

.cu-tag.badge {
  position: absolute;
  top: 0.2rem;
  right: -0.2702702702702703rem;
  font-size: 0.5405405405405406rem;
  padding: 0rem 0.2702702702702703rem;
  background-color: #dd514c;
  color: #fff;
  border-radius: 5.405405405405405rem;
  font-family: Helvetica Neue, Helvetica, sans-serif;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/mindex.vue